<div class="activity-container flex flex-col w-100-percent">
    <div class="flex flex-row basis-full items-center justify-between">
        <span class="title">{{'ACTIVITY_DETAILS.TITLE' | transloco}}</span>
        <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="closepopup()"></mat-icon>
    </div>
    <mat-divider class="w-100-percent neutral-2 mt-16"></mat-divider>

    <div class="status-info flex flex-col mb-16 mt-16 p-16">
        <div class="flex flex-row basis-full items-center justify-between">
            <span class="status">{{instanceStatus.toUpperCase()}}</span>
            <mat-icon svgIcon="refresh" class="refresh-circle icons transition-transform duration-700 mb-14" [ngClass]="{ 'animate-spin': dataLoading }" (click)="refreshClick()"></mat-icon>
        </div>
        @if (componentExecStage?.count && componentExecStage?.count?.total ) {
            <div class="progress-wrapper mt-40">
                <div class="progress-fill" [style.width.%]="progressPercent"></div>
                <div class="progress-track"></div>
                <div class="progress-glow" [style.--progress]="progressPercent + '%'"></div>
            </div>
        } @else {
            <mat-progress-bar class="progress-bar mt-40 mb-12" mode="indeterminate" [value]="0"></mat-progress-bar>
        }
        <div class="flex flex-row items-center mt-20 mb-10" [ngClass]="isComponentAvailable ? 'justify-between' : 'justify-end'">
            @if (isComponentAvailable || componentExecStage?.count?.total) {
                @if (dataLoading) {
                    <div class="flex item-center ml-4 pl-6 pr-16 loader">
                        <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                    </div>
                } @else {
                    <div class="flex flex-row gap-2 justify-center items-center">
                        <span class="count">{{countData?.completed + '/' + countData?.total + ' completed'  }}</span>
                        <mat-icon svgIcon="Ellipse" class="w-2 h-2 mt--30"></mat-icon>
                        <span class="count">{{countData?.pending + ' pending'}}</span>
                        <mat-icon svgIcon="Ellipse" class="w-2 h-2 mt--30"></mat-icon>
                        <span class="count">{{countData?.skipped + ' skipped' }}</span>
                    </div>
                }
            }
            <div class="flex flex-row gap-1 justify-center">
                <mat-icon svgIcon="share_eta" class="w-14 h-14 mt--2"></mat-icon>
                <span class="count mt-2"> {{'ACTIVITY_DETAILS.EST_TIME_LEFT' | transloco}} </span>
                @if(dataLoading) {
                    <div class="flex item-center ml-4 pl-6 pr-16 loader">
                        <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                    </div>
                } @else {
                    <span class="time">{{ estimatedtime !== '' ? estimatedtime : '--'}}</span>
                }
            </div>
        </div>
    </div>
    @if(isComponentAvailable) {
        <div class="flex flex-row status-buttons">
            @for (status of FilterColumns; track status.key) {
                @if (dataLoading) {
                    <button mat-button (click)="selectStatus(status.key)" class="mr-12 status-btn" [ngClass]="selectedStatus === status.key ? 'btn-active' : 'btn-inactive'">
                        {{ status.label }}
                        <div class="flex item-center w-10 h-10" [ngClass]="selectedStatus === status.key ? 'loader-2' : 'loader-3'">
                            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                        </div>
                    </button>
                } @else {
                    <button mat-button (click)="selectStatus(status.key)" class="mr-12 status-btn" [ngClass]="selectedStatus === status.key ? 'btn-active' : 'btn-inactive'">{{ status.label }}{{ status.count }}</button>
                }
            }
        </div>
        <div class="mt-16 mb-16">
            <app-environment-table class="component-table" [initialDataSource]="filteredComponents" [displayColumns]="displayColumns" [dataLoading]="dataLoading" [showSkeletonLoader]="true" page="activityDetails" [dataSourceLength]="true" [initialCreate]="allComponents?.length === 0" pageName="activityDetails" [noDataMessage]="noDataMessage"></app-environment-table>
        </div>
    } @else {
        @if (!dataLoading) {
            <div class="empty-data flex flex-col items-center mt-32 ">
                <img class="w-106" alt="components not found" src="/assets/images/service_not_found.png">
                <div class="flex mt-6 ">{{'ACTIVITY_DETAILS.NO_COMPONENTS' | transloco }}</div>
            </div>
        } @else {
            <div class="loader-section">
                <div class="runbook-group loader-header flex flex-col p-16">
                    <div class="flex flex-row">
                        @for (tableColumn of displayColumns; track tableColumn?.key) {
                            <div class="loader-style"><ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader></div>
                        }
                    </div>
                </div>
                @for (item of [1, 2, 3]; track $index) {
                    <div class="w-100-percent">
                        <div class="column-group flex flex-col p-16">
                            <div class="flex flex-row">
                                @for (tableColumn of displayColumns; track tableColumn?.key) {
                                    <div class="loader-style"><ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader></div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    }
</div>